import type { StaticImageData } from "next/image"

export function isImgixImage(image?: string | StaticImageData | null) {
  if (!image || typeof image !== "string") return false
  return /https:\/\/(.+)\.imgix\.net\/.*/.test(image)
}

export function getImgixUrl({
  src,
  width,
  height,
  quality,
  format,
}: {
  src: string
  width: number
  height?: number
  quality?: number
  format?: string
}) {
  if (!isImgixImage(src)) return src

  const url = new URL(src)
  const params = url.searchParams

  params.set("w", width.toString())
  params.set("auto", "format,compress")

  if (height) params.set("h", height.toString())
  if (format) params.set("fm", format)
  if (quality) params.set("q", quality.toString())

  params.set("fit", params.get("fit") || "max")

  return url.href
}
